
import {Outlet, useLocation} from "react-router-dom";

const Profile = () => {
    const location = useLocation();
    const routeWidths = [
        {path: '/add'},
    ];
    const currentWidth = routeWidths.find(route => location.pathname.includes(route.path)) || 'auto';

    return (
        <div className="p-4">
            <Outlet/>
        </div>
    )
}
export default Profile;
